var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.autocompleteText,
        expression: "autocompleteText"
      }
    ],
    ref: "autocomplete",
    class: _vm.classname,
    attrs: {
      type: "text",
      id: _vm.id,
      placeholder: _vm.placeholder,
      disabled: _vm.disabled
    },
    domProps: { value: _vm.autocompleteText },
    on: {
      focus: function($event) {
        return _vm.onFocus()
      },
      blur: function($event) {
        return _vm.onBlur()
      },
      change: _vm.onChange,
      keypress: _vm.onKeyPress,
      keyup: _vm.onKeyUp,
      input: function($event) {
        if ($event.target.composing) {
          return
        }
        _vm.autocompleteText = $event.target.value
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a72a90ea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a72a90ea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-google-autocomplete/src/VueGoogleAutocomplete.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-a72a90ea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-google-autocomplete/src/VueGoogleAutocomplete.vue
// module chunks = 0